<template>
  <div class="supplier-detail-list">
    <div v-for="(item, index) in table" :key="`m-${index}`" class="list-item">
      <div class="list-item-title flex">
        <div class="list-item-title-name text-bold">
          {{ getTitle(item, index) }}
        </div>
        <div v-if="item.remark" class="list-item-title-remark m-l-8">
          {{ item.remark }}
        </div>
      </div>
      <div class="list-item-content">
        <template v-if="item.content">
          <p v-if="item.materialType === otherMaterialTypeDict.TEXT.value">
            {{ item.content }}
          </p>
          <template
            v-if="item.materialType === otherMaterialTypeDict.ATTACHMENT.value"
          >
            <upload
              v-if="uploadMode === 'fileId'"
              ref="uploadFile"
              :file-id-before.sync="item.content"
              :props-data="{
                uploadMode: 'fileId',
                disabled: true
              }"
            />
            <upload
              v-else
              :props-data="{
                groupIdBefore: item.content,
                disabled: true
              }"
            />
          </template>
        </template>
        <p v-else>-</p>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
import {
  otherMaterialRequirementDict,
  otherMaterialTypeDict
} from '@/dictionary/project/common'

export default {
  name: 'SupplierDetailList',

  components: { Upload },

  props: {
    table: {
      type: Array,
      default: () => []
    },

    uploadMode: {
      type: String,
      default: 'groupId'
    }
  },

  data() {
    return {
      // 材料类型
      otherMaterialTypeDict,

      // 是否必填
      otherMaterialRequirementDict
    }
  },

  methods: {
    /**
     * 获取材料显示的标题
     */
    getTitle(item, index) {
      return `${index + 1}. ${item.materialName}`
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  margin-right: 20px;
  margin-bottom: 10px;
  .list-item-title-remark {
    color: $fourth-text-color;
  }
  .list-item-content {
    margin-top: 16px;
    color: $second-text-color;
  }
}
</style>
